export default __webpack_public_path__ + "static/media/Jerry Nadler.e231d9ef.jpg";